import React, { useState, useEffect } from "react"
import {
  Col,
  Card,
  Nav,
  CardBody,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
  Row,
} from "reactstrap"
import classnames from "classnames"
import { SuccessOk } from "configs/statusCode";
import ReactApexChart from "react-apexcharts"
import DashboardService from "services/Provider/DashboardService"
import { AvForm, AvField  } from 'availity-reactstrap-validation';

 
const cardsTypes = ["deals", "leads", "appointments","units"]

const Transactions = ({appointment}) => {
   const dashboardService = new DashboardService()
  const [dashboardData, setDashboardData] = useState(null)
  const [month, setMonth] = useState("")
  const [activeTab, setactiveTab] = useState("1")
  

  
  useEffect(() => {
    cardsTypes.map(item => {
      let data = {
        [`${item}`]: 1
      }
      if (month.length) data["date"] = month
       dashboardService.getList(data).then((res) => {
        if (res && res.status === SuccessOk) {
          setDashboardData(data => ({
            ...data,
            ...res.data
          }))
        }
      })
    })
  }, [month]);
  
  useEffect(() => {
    
          setDashboardData(data => ({
            ...data,
            appointmentTotal:appointment
          }))
       
  }, [appointment]);

   
const walletOptions = {
  plotOptions: {
    radialBar: {
      offsetY: 0,
      startAngle: 0,
      endAngle: 270,
      hollow: {
        margin: 5,
        size: "25%",
        background: "transparent",
        image: void 0,
      },
      track: {
        show: !0,
        startAngle: void 0,
        endAngle: void 0,
        background: "#f2f2f2",
        strokeWidth: "97%",
        opacity: 1,
        margin: 12,
        dropShadow: {
          enabled: !1,
          top: 0,
          left: 0,
          blur: 3,
          opacity: 0.5,
        },
      },
      dataLabels: {
        name: {
          show: !0,
          fontSize: "16px",
          fontWeight: 600,
          offsetY: -10,
        },
        value: {
          show: !0,
          fontSize: "14px",
          offsetY: 4,
          formatter: function (e) {
            return e + "%"
          },
        },
        total: {
          show: !0,
          label: "Total Units",
          color: "#373d3f",
          fontSize: "16px",
          fontFamily: void 0,
          fontWeight: 600,
          formatter: function (e) {
            return  `${dashboardData?.units ? dashboardData?.units: 0}`
          },
        },
        
      },
    },
  },
  stroke: {
    lineCap: "round",
  },
  colors: ["#3452e1", "#f1b44c", "#c242aa","#5ac242"],
  labels: ["Deals", "Leads","Upcoming APPT","Done APPT"],
  legend: { show: !1 },
}
 
return (
  <React.Fragment>
    <Col>
      <Card style={{minHeight:"85.8vh"}}>
        <CardBody>
        <Row className="mb-0">
              <Col md={6} className="pt-3"> 
              <h4 className="card-title mb-4">Statistics</h4>
             </Col>
              <Col md={6} className="d-flex justify-content-end"  >
              <AvForm>
                <AvField
                   name={"date"}
                   bsSize="lg"
                   value={month}
                  onChange={e =>  setMonth(e.target.value)}
                   type="month"
                 />
                 </AvForm>
              </Col>
            </Row>
          {false ? <Nav pills className="bg-light rounded" role="tablist">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
  
              >
                All
                </NavLink>
            </NavItem>             
          </Nav> :null}
          <TabContent activeTab={activeTab} className="mt-4">
            <TabPane tabId="1">
              <div>
                <Row className="px-3">

                  <Col sm="12">
                    <div className="mx-auto">
                      <div id="wallet-balance-chart">
                         {dashboardData?.units ? <ReactApexChart
                          options={walletOptions}
                          series={[
                            dashboardData ?.leads ?.percentage ? dashboardData ?.leads ?.percentage : 0,
                            dashboardData ?.deals ?.percentage ? dashboardData ?.deals ?.percentage : 0 ,
                             dashboardData ?.appointments ?.upcomingPercentage  ?dashboardData ?.appointments ?.upcomingPercentage: 0 ,
                             dashboardData ?.appointments ?.donePercentage  ?dashboardData ?.appointments ?.donePercentage: 0 
                            ]}
                          type="radialBar"
                          height={300}
                          className="apex-charts"
                        />:null}

                      </div>
                    </div>
                  </Col>

                <Row className="d-flex justify-content-between">
                  <Col sm="12" lg={4} md={6} className="align-self-center">
                    <div className="mt-4 pt-2 ">
                      <p className="mb-2">
                        <i className="mdi mdi-circle align-middle font-size-10 me-1 text-primary" />{" "}
                        Leads {dashboardData ?.leads ?.percentage}%
                        </p>
                      <h5>
                      <span className=" font-size-14 align-subInfo" >{dashboardData ?.leads ?.leadsCount} Leads Count</span>
                      </h5>
                    </div>
                  </Col>
                  <Col sm="12" lg={4} md={6} className="align-self-center">
                    <div className="mt-4 pt-2 ">
                      <p className="mb-2">
                        <i className="mdi mdi-circle align-middle font-size-10 me-1 text-warning" />{" "}
                        Deals {dashboardData ?.deals ?.percentage}%
                        </p>
                      <h5>
                      <span className=" font-size-14 align-subInfo" >{dashboardData ?.deals ?.dealssCount}  Deals Count</span>
                      </h5>
                    </div>
                  </Col>
                   <Col sm="12" lg={4} md={6} className="align-self-center">
                   <div className="mt-4 pt-2 ">
                     <p className="mb-2">
                       <i className="mdi mdi-circle align-middle font-size-10 me-1" style={{color:"#c242aa"}} />{" "}
                       Upcoming APPT {dashboardData ?.appointments ?.upcomingPercentage}%
                       </p>
                     <h5>
                       <span className="font-size-14 align-subInfo" >{dashboardData ?.appointmentTotal} APPT Count</span>
                     </h5>
                   </div>
                 </Col>
                  <Col sm="12" lg={4} md={6} className="align-self-center">
                  <div className="mt-4 pt-2 ">
                    <p className="mb-2">
                      <i className="mdi mdi-circle align-middle font-size-10 me-1" style={{color:"#5ac242"}} />{" "}
                      Done APPT {dashboardData ?.appointments ?.donePercentage}%
                      </p>
                    <h5>
                      <span className=" font-size-14 align-subInfo"  >{dashboardData ?.appointmentTotal} APPT Count</span>
                    </h5>
                  </div>
                </Col>
                </Row>
                </Row>
              </div>
            </TabPane>
           </TabContent>
        </CardBody>
      </Card>
    </Col>
  </React.Fragment>
)
}


export default Transactions
